import { ScenarioDocument } from "../types";

export const downloadFile = (doc: ScenarioDocument) => {
  // The URL is a short-lived signed GCS link. Open in a new tab so the browser
  // handles rendering (PDF viewer) or download (CSV) based on Content-Type.
  window.open(doc.url, "_blank", "noopener,noreferrer");
};
